import { type FC } from 'react';
import {
  CollectionSalesInfoContainer, CollectionSalesInfoItem,
  CollectionSalesItemHeading, CollectionSalesItemValue,
} from './styled';
import { type CollectionSaleInfoProps } from './types';
import { numberWithCommas } from '../../helpers/TextHelpers';

const CollectionSalesInfo: FC<CollectionSaleInfoProps> = ({
  inCirculation,
  uniqueOwners,
  topSale,
  volumeTraded,
}) => (
  <CollectionSalesInfoContainer data-test-id="collection_sales_info_container">
    <CollectionSalesInfoItem>
      <CollectionSalesItemValue data-test-id="collection_sales_item_value_1" data-incirculation-attribute={inCirculation}>
        {numberWithCommas(inCirculation, 0)}
      </CollectionSalesItemValue>
      <CollectionSalesItemHeading data-test-id="collection_sales_item_heading_1">
        In circulation
      </CollectionSalesItemHeading>
    </CollectionSalesInfoItem>
    <CollectionSalesInfoItem>
      <CollectionSalesItemValue data-test-id="collection_sales_item_value_2" data-buyers-attribute={uniqueOwners}>
        {numberWithCommas(uniqueOwners, 0)}
      </CollectionSalesItemValue>
      <CollectionSalesItemHeading data-test-id="collection_sales_item_heading_2">
        Unique owners
      </CollectionSalesItemHeading>
    </CollectionSalesInfoItem>
    <CollectionSalesInfoItem>
      <CollectionSalesItemValue data-test-id="collection_sales_item_value_3">
        $
        {numberWithCommas(topSale, 0)}
      </CollectionSalesItemValue>
      <CollectionSalesItemHeading data-test-id="collection_sales_item_heading_3">
        Top sale
      </CollectionSalesItemHeading>
    </CollectionSalesInfoItem>
    <CollectionSalesInfoItem>
      <CollectionSalesItemValue data-test-id="collection_sales_item_value_4" data-sales-attribute={volumeTraded}>
        $
        {numberWithCommas(volumeTraded, 0)}
      </CollectionSalesItemValue>
      <CollectionSalesItemHeading data-test-id="collection_sales_item_heading_4">
        Volume traded
      </CollectionSalesItemHeading>
    </CollectionSalesInfoItem>
  </CollectionSalesInfoContainer>
);

export default CollectionSalesInfo;
